import { ComponentPath } from './types'

export function getComponentFromPath(path: ComponentPath): string {
  if (path.component) {
    return path.component
  } else if (path.url) {
    return path.url.replace(/^\//, '').replace(/\/$/, '')
  }

  throw new Error(`Invalid \`ComponentPath\`: "${JSON.stringify(path)}"`)
}

export function getPageForPath<TPages>(path: ComponentPath, pages: Record<string, TPages>): TPages {
  const base = `../../pages/${getComponentFromPath(path)}/Page`
  return pages[`${base}.tsx`] || pages[`${base}.jsx`]
}

export function getLayoutsForPath<TLayouts>(
  path: ComponentPath,
  layouts: Record<string, TLayouts>,
): TLayouts[] {
  const segments = getComponentFromPath(path).split('/')
  const layoutsForPath: TLayouts[] = []

  for (let i = segments.length; i > 0; i -= 1) {
    const layoutPath = segments.slice(0, i).join('/')
    const base = `../../pages/${layoutPath}/Layout`
    const layout = layouts[`${base}.tsx`] || layouts[`${base}.jsx`]

    if (layout) {
      layoutsForPath.push(layout)
    }
  }

  return layoutsForPath.reverse()
}
